import {getStore} from '../../redux/store'
import {openSupportForm as openForm} from './actions'
import {getLocalStorage} from '../../util/LocalStorage'
import {supportPopupPositionStrategy} from './constants'

/**
 * @deprecated This function connects directly to redux, which is discouraged. Dispatch pure redux version from actions instead.
 */
export function openSupportForm() {
    getStore().dispatch(openForm({
        positionStrategy: supportPopupPositionStrategy.CENTER,
        position: {x: 0, y: 0,},
    }))
}

export const SUPPORT_POPUP_INFO_LOCAL_STORAGE_KEY = 'supportPopupInfo'

export const getSupportPopupInfoFromLocalStorage = () => {
    return getLocalStorage().getItem(SUPPORT_POPUP_INFO_LOCAL_STORAGE_KEY)
}

export const setSupportPopupInfoToLocalStorage = (info) => {
    getLocalStorage().setItem(SUPPORT_POPUP_INFO_LOCAL_STORAGE_KEY, info)
}



// WEBPACK FOOTER //
// ./web/js/support/supportForm/utils.js